import AppRoutes from '../routes/appRoutes'

export const handleOnDone = (history, requestId, handleChangeOpen, type) => {
    if (type === 'Repair') {
        history?.replace(AppRoutes.viewServiceRequest(requestId))
    } else if (type === 'Parts') {
        history?.replace(AppRoutes.viewPartsRequest(requestId))
    }

    handleChangeOpen(false)
    removeStepsAndRequests()
}
export const handleOnCancel = history => {
    history?.push(AppRoutes.dashboard())
    removeStepsAndRequests()
}

export const removeStepsAndRequests = () => {
    localStorage.removeItem('repairRequestState')
    localStorage.removeItem('repairRequestForm')
    localStorage.removeItem('partsRequestState')
    localStorage.removeItem('partsRequestForm')
}
